// Ported from vlookup-dramatic/components/button-link.tsx by scripts/revamp/port-design.js
import React from "react";
import Link from "./link";
import { buttonVariants } from "./ui/button";
import { cn } from "../lib/utils";
import { useLoggedIn } from "../hooks/use-logged-in";
import { isJoinHref } from "../lib/signup-modal";
export function ButtonLink({ className, variant, size, href, ...props }) {
    const loggedIn = useLoggedIn();
    if (loggedIn && isJoinHref(href)) return null;
    return (<Link href={href} className={cn(buttonVariants({ variant, size }), className)} {...props}/>);
}
